
<script>
export default {
	created: function() {
    	this.$store.commit('setContentLoaded', true); // then footer will be displayed

    	// Specify the actual redirect, that will take the user out of the app entirely...		
        // Redirect outside the app using plain old javascript
        window.location.href = "/404page.html";		
    }  
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue